import { useLocation } from 'react-router-dom';

export const useIsInRoute = (routeToFind: string) => {
	const location = useLocation();
	const pathNameParts = location.pathname.split('/').map((path) => path.toLowerCase());
	pathNameParts.shift();
	return pathNameParts.includes(routeToFind.toLowerCase());
}